import { useCompassCard } from '@scale/compass-ui/store';
import { EditorDoc } from 'react-scale/corp/components/CodeMirror';
import { useEffect } from 'react';
import { isInvalidQuery } from 'react-scale/corp/views/CorpProjectGroupManager/utils';
import type { SnowflakeSqlContext } from '@scale/genai-compass-shared/cards/snowflake_sql';

function useSnowflakeSqlCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit, error } = useCompassCard(index);
  const context = card.defaultContext as SnowflakeSqlContext;

  const setCode = (code: EditorDoc) => {
    const updatedContext: SnowflakeSqlContext = {
      ...context,
      code: code.toString(),
    };
    updateCardContext(updatedContext);
  };

  useEffect(() => {
    if (isInvalidQuery(context.code.toString())) {
      updateCardCanSubmit(false);
    } else {
      updateCardCanSubmit(true);
    }
  }, [context.code]);

  return {
    code: context.code,
    setCode,
    hasError: !!error,
  };
}

export default useSnowflakeSqlCard;
